export default {
  // ProviderVoicesEditor 音色管理
  'pages.providerVoicesEditor.msg.deleted': '已刪除音色',
  'pages.providerVoicesEditor.msg.nameRequired': 'name 為必填項',
  'pages.providerVoicesEditor.msg.displayNameRequired': 'display_name 為必填項',
  'pages.providerVoicesEditor.msg.saveSuccess': '儲存成功',
  'pages.providerVoicesEditor.msg.savedList': '已儲存音色列表',
  'pages.providerVoicesEditor.msg.pastePrompt': '請貼上 JSON 或 YAML 陣列',
  'pages.providerVoicesEditor.msg.parseFailed': '解析失敗，請檢查 JSON/YAML 格式',
  'pages.providerVoicesEditor.msg.mustBeArray': '匯入格式應為陣列（JSON 或 YAML）',
  'pages.providerVoicesEditor.msg.importSuccess': '成功匯入 {n} 條音色',
  'pages.providerVoicesEditor.msg.cleared': '已清空音色列表',
  'pages.providerVoicesEditor.drawer.title': '管理音色',
  'pages.providerVoicesEditor.btn.importJson': '匯入 JSON/YAML',
  'pages.providerVoicesEditor.btn.clear': '清空',
  'pages.providerVoicesEditor.btn.saveClose': '儲存並關閉',
  'pages.providerVoicesEditor.btn.add': '新增音色',
  'pages.providerVoicesEditor.btn.pasteImport': '貼上匯入 (JSON/YAML)',
  'pages.providerVoicesEditor.btn.preview': '試聽',
  'pages.providerVoicesEditor.btn.edit': '編輯',
  'pages.providerVoicesEditor.btn.delete': '刪除',
  'pages.providerVoicesEditor.list.language': '語種',
  'pages.providerVoicesEditor.list.mandarin': '普通話',
  'pages.providerVoicesEditor.modal.editTitle': '編輯音色',
  'pages.providerVoicesEditor.modal.addTitle': '新增音色',
  'pages.providerVoicesEditor.label.voiceId': '音色id *',
  'pages.providerVoicesEditor.label.displayName': '顯示名字 *',
  'pages.providerVoicesEditor.label.sex': '性別',
  'pages.providerVoicesEditor.label.description': '描述',
  'pages.providerVoicesEditor.label.audioUrl': '試聽音訊連結',
  'pages.providerVoicesEditor.label.language': '語言',
  'pages.providerVoicesEditor.placeholder.language': '如 普通話、英語、粵語、日語',
  'pages.providerVoicesEditor.import.title': '匯入 JSON/YAML 陣列',
  'pages.providerVoicesEditor.import.appendOk': '追加匯入',
  'pages.providerVoicesEditor.import.replaceAll': '替換全部並匯入',
  'pages.providerVoicesEditor.import.loadSample': '載入示例',
  'pages.providerVoicesEditor.import.placeholder': '請貼上 JSON 或 YAML 陣列，格式示例可透過“載入示例”按鈕插入',

  // LogViewer 日誌檢視
  'pages.admin.ops.logViewer.fetchFailed': '獲取日誌列表失敗',
  'pages.admin.ops.logViewer.downloadFailed': '下載失敗',
  'pages.admin.ops.logViewer.previewFailed': '預覽失敗',
  'pages.admin.ops.logViewer.columnName': '檔名',
  'pages.admin.ops.logViewer.columnSize': '大小 (位元組)',
  'pages.admin.ops.logViewer.columnMtime': '修改時間',
  'pages.admin.ops.logViewer.columnAction': '操作',
  'pages.admin.ops.logViewer.download': '下載',
  'pages.admin.ops.logViewer.refresh': '重新整理',

  // OssMediaUpload OSS 媒體上傳
  'pages.ossMediaUpload.sizeExceed': '檔案大小不能超過 {n}MB',
  'pages.ossMediaUpload.formatOnly': '僅支援格式：{formats}',
  'pages.ossMediaUpload.selectImage': '請選擇圖片檔案',
  'pages.ossMediaUpload.selectVideo': '請選擇影片檔案',
  'pages.ossMediaUpload.uploadSuccess': '上傳成功',
  'pages.ossMediaUpload.uploadFailed': '上傳失敗',
  'pages.ossMediaUpload.dragText': '點選或拖拽檔案到此上傳',
  'pages.ossMediaUpload.dragHint': '將儲存到 OSS，提交表單時請儲存',
  'pages.ossMediaUpload.uploadedFile': '已上傳檔案',

  // LLMProvider 供應商配置
  'pages.admin.providerModal.coze.token.placeholder': '請輸入 Coze Token',
  'pages.admin.providerModal.coze.botid.placeholder': '請輸入 Coze Bot ID',
  'pages.admin.providerModal.coze.userid.placeholder': '可選：Coze User ID',
  'pages.admin.providerModal.coze.botid.required': '請輸入 Bot ID',
  'pages.admin.providerModal.commercialLicenseOnly': '僅允許商業授權裝置使用（需商業版智慧體）',

  // VLLLMProvider 安全配置
  'pages.admin.providerModal.security.maxFileSize': '最大檔案大小 (位元組)',
  'pages.admin.providerModal.security.maxPixels': '最大畫素數',
  'pages.admin.providerModal.security.maxWidth': '最大寬度',
  'pages.admin.providerModal.security.maxHeight': '最大高度',
  'pages.admin.providerModal.security.allowedFormats': '允許的格式',

  // ProviderCard 供應商卡片
  'pages.admin.providerCard.config.presetModel': '預設模型',
  'pages.admin.providerCard.config.cloneModel': '克隆合成模型',

  // TTSProvider 克隆音色
  'pages.admin.providerModal.voiceCloneModel.label': '克隆音色合成模型',
  'pages.admin.providerModal.voiceCloneModel.hint': '預設音色使用上方模型；克隆音色合成時使用此 VC 模型，須與克隆 API 的 target_model 一致',
  'pages.admin.providerModal.voiceCloneModel.hintCosyvoice': '須與上方合成模型一致（如 cosyvoice-v3-flash）；留空則自動使用上方模型',

  // Footer 頁尾
  'pages.footer.copyright': '© 賽搏 Ai',

  // KnowledgeBaseRecallTestModal 召回測試
  'pages.knowledgeBase.recall.resultFallback': '結果',

  // CancelAccount 登出賬號
  'cancelAccount.warning1': '賬號登出後，您的所有個人資訊、裝置繫結記錄及使用資料將被永久刪除。',
  'cancelAccount.warning2': '登出操作不可逆轉，無法恢復已刪除的任何資料。',
  'cancelAccount.warning3': '繫結的裝置將自動解綁，可能影響裝置的正常使用。',
  'cancelAccount.warning4': '如有未消耗的餘額或權益，將自動作廢且無法退還。',
  'cancelAccount.pleaseEnterEmail': '請輸入您的賬號郵箱',
  'cancelAccount.invalidEmail': '請輸入格式正確的郵箱地址',
  'cancelAccount.confirmDialogTitle': '確認申請登出賬號？',
  'cancelAccount.confirmDialogDesc': '請仔細閱讀上方風險提示。點選確認將生成登出郵件。',
  'cancelAccount.accountLabel': '賬號：',
  'cancelAccount.confirmDialogConfirm': '確認申請',
  'cancelAccount.confirmDialogCancel': '取消',
  'cancelAccount.emailSubject': '【賬號登出申請】',
  'cancelAccount.emailBody': '您好，我需要申請登出以下賬號：',
  'cancelAccount.emailAccountLabel': '登出賬號：',
  'cancelAccount.emailReasonLabel': '登出原因：',
  'cancelAccount.successDialogTitle': '登出申請郵件已生成',
  'cancelAccount.successDialogDesc': '若您的裝置未能自動跳轉到郵件客戶端，請手動複製下方客服郵箱，併傳送您的登出申請。',
  'cancelAccount.successDialogNote': '我們將在收到郵件後的 7 個工作日內為您處理。',
  'cancelAccount.copySuccess': '郵箱已複製',
  'cancelAccount.copy': '複製',
  'cancelAccount.gotIt': '好的',
  'cancelAccount.headerTitle': '登出賬號',
  'cancelAccount.headerSubtitle': '登出後將永久刪除所有資料且不可恢復，請謹慎操作。',
  'cancelAccount.warningTitle': '登出賬號風險提示',
  'cancelAccount.emailSectionTitle': '確認賬號資訊',
  'cancelAccount.emailSectionDesc': '請輸入需要登出的賬號郵箱',
  'cancelAccount.emailPlaceholder': '請輸入賬號郵箱',
  'cancelAccount.reasonTitle': '登出原因',
  'cancelAccount.optional': '(選填)',
  'cancelAccount.reasonPlaceholder': '請告訴我們您登出的原因，幫助我們改進服務...',
  'cancelAccount.submitButton': '提交登出申請',

  // ASRProvider 小語種斷句
  'pages.admin.providerModal.nostreamSilence.title': '小語種斷句（高階）',
  'pages.admin.providerModal.nostreamSilence.hint':
    '小語種（如俄語）靜默判停毫秒：值越大整句越完整、值越小響應越快。留空用預設 450/600/750。檔位由智慧體 asrSpeed 決定走哪一檔（1 耐心 / 2 正常 / 3 快速）',
  'pages.admin.providerModal.nostreamSilence.fast': '靜默判停·快速檔 (ms)',
  'pages.admin.providerModal.nostreamSilence.normal': '靜默判停·正常檔 (ms)',
  'pages.admin.providerModal.nostreamSilence.slow': '靜默判停·耐心檔 (ms)',

  // 麥克風許可權錯誤
  'helpers.media.unsupportedEnv': '當前環境不支援訪問麥克風',
  'helpers.media.insecureContext':
    '麥克風需在安全環境（HTTPS 或 localhost）下使用；當前頁面地址不安全，無法呼叫麥克風。',
  'helpers.media.browserUnsupported':
    '當前瀏覽器不支援麥克風訪問，請使用最新 Microsoft Edge 或 Google Chrome。',

  // Register / ForgotPassword 簡訊傳送
  'pages.register.smsCode.sendFailed': '傳送失敗',
  'pages.forgotPassword.smsCode.sendFailed': '傳送失敗',

  // Welcome 歡迎頁
  'pages.welcome.greetingLine': '{greeting}，{name}',
};
